export default "__VITE_PUBLIC_ASSET__b8a1c632__"